export enum TaskCategory {
  ENTRY            = 'entry',
  ES_SUBMISSION    = 'es_submission',
  APTITUDE_TEST    = 'aptitude_test',
  FIRST_INTERVIEW  = 'first_interview',
  SECOND_INTERVIEW = 'second_interview',
  FINAL_INTERVIEW  = 'final_interview',
  OFFER            = 'offer',
}

export enum TaskPriority {
  HIGH   = 'high',
  MEDIUM = 'medium',
  LOW    = 'low',
}

export enum TaskStatus {
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  COMPLETED   = 'completed',
}

export interface SubTaskItem {
  id:           string;
  title:        string;
  is_completed: boolean;
}

export interface TaskData {
  id:                   number;
  title:                string;
  description:          string | null;
  category:             TaskCategory;
  priority:             TaskPriority;
  status:               TaskStatus;
  due_date:             string;
  scheduled_time_start: string | null;
  location:             string | null;
  sub_tasks:            SubTaskItem[] | null;
  company_name:         string | null;
  created_at:           string;
  updated_at:           string;
}

export interface CreateTaskRequest {
  title:                 string;
  description?:          string | null;
  category:              TaskCategory;
  priority:              TaskPriority;
  due_date:              string;
  scheduled_time_start?: string | null;
  location?:             string | null;
  sub_tasks?:            SubTaskItem[] | null;
  company_name?:         string | null;
}

export interface UpdateTaskRequest {
  title?:                string;
  description?:          string | null;
  category?:             TaskCategory;
  priority?:             TaskPriority;
  status?:               TaskStatus;
  due_date?:             string;
  scheduled_time_start?: string | null;
  location?:             string | null;
  sub_tasks?:            SubTaskItem[] | null;
  company_name?:         string | null;
}

export interface GetTasksQuery {
  status?:     TaskStatus;
  priority?:   TaskPriority;
  category?:   TaskCategory;
  sort_by?:    'due_date' | 'created_at' | 'priority';
  sort_order?: 'asc' | 'desc';
  page?:       number;
  limit?:      number;
  year?:       number;
  month?:      number;
}

export const CATEGORY_LABELS: Record<TaskCategory, string> = {
  [TaskCategory.ENTRY]:            'エントリー',
  [TaskCategory.ES_SUBMISSION]:    'ES提出',
  [TaskCategory.APTITUDE_TEST]:    '適性検査',
  [TaskCategory.FIRST_INTERVIEW]:  '一次面接',
  [TaskCategory.SECOND_INTERVIEW]: '二次面接',
  [TaskCategory.FINAL_INTERVIEW]:  '最終面接',
  [TaskCategory.OFFER]:            '内定',
};

export const PRIORITY_LABELS: Record<TaskPriority, string> = {
  [TaskPriority.HIGH]:   '高',
  [TaskPriority.MEDIUM]: '中',
  [TaskPriority.LOW]:    '低',
};

export const STATUS_LABELS: Record<TaskStatus, string> = {
  [TaskStatus.NOT_STARTED]: '未着手',
  [TaskStatus.IN_PROGRESS]: '進行中',
  [TaskStatus.COMPLETED]:   '完了',
};
